export default __webpack_public_path__ + "static/media/muteActive.8d5ef93a.svg";